import { ErrorMessageWrapper } from "@/common/components/ErrorMessageWrapper";
import ListFilters from "@/common/components/ListFilters";
import ListHeader from "@/common/components/ListHeader";
import Table from "@/common/components/Table";
import useDebounce from "@/common/hooks/useDebounce";
import { useFilterParams } from "@/common/hooks/useFilterParams";
import { Mapper } from "@/common/services/mapper";
import { HandshakeIcon } from "lucide-react";
import { negotiationsListTableColumns } from "../../constants/negotiationsListTableColumns.constant";
import { useNegotiations } from "../../hooks/useNegotiations";
import { NegotiationsTransformer } from "../../services/NegotiationsTransformer";
import { negotiationStatusOptions } from "../../constants/negotiationStatus.constant";
import { useCompanies } from "@/common/hooks/queries/useCompanies";
import { CompaniesTransformer } from "@/common/services/companiesTransformer";

const NegotiationsList = () => {
  const { filterParams, setFilterParams } = useFilterParams();

  const [searchCompany, setSearchCompany] = useDebounce('');

  const { data: companiesOptions } = useCompanies({
    filters: {
      search: searchCompany,
    },
    mapper: Mapper.mapWithTransformer({ transformer: CompaniesTransformer.optionsTransformer() }),
  });

  const {
    data: negotiations,
    meta,
    isFetching: negotiationsIsFetching,
    error: negotiationsError = {} as any,
    refetch: negotiationsRefetch,
  } = useNegotiations({
    filters: {
      page: filterParams.page || 1,
      status: filterParams.status?.value,
      client_company_id: filterParams.company?.value,
    },
    mapper: Mapper.mapWithTransformer({ transformer: NegotiationsTransformer.tableTransformer() }),
  });

  return (
    <div className="flex flex-col gap-6">
      <div className="flex">
        <ListHeader
          Icon={<HandshakeIcon className="w-10 h-10" strokeWidth={1.5} />}
          title="Negociações"
        />
      </div>

      <ErrorMessageWrapper
        className="max-h-[calc(100vh-128px)]"
        statusCode={negotiationsError?.status}
        refetchFunction={negotiationsRefetch}
      >
        <div className="h-[calc(100vh-128px)] flex flex-col gap-6">
          <div className="flex flex-col gap-4">
            <div className="flex items-center gap-4">
              <ListFilters
                filters={[
                  {
                    className: 'min-w-40',
                    onChange: (e: any) => setFilterParams((params) => ({ ...params, status: e?.value ? e : null, page: null })),
                    value: filterParams?.status || '',
                    options: [{ label: 'Todas', value: '' }, ...negotiationStatusOptions],
                    placeholder: 'Status',
                  },
                  {
                    className: 'min-w-40',
                    onChange: (e: any) => setFilterParams((params) => ({ ...params, company: e?.value ? e : null, page: null })),
                    onInputChange: setSearchCompany,
                    value: filterParams?.company || '',
                    options: [{ label: 'Todas', value: '' }, ...companiesOptions],
                    placeholder: 'Empresa',
                  },
                ]}
              />
            </div>
          </div>

          <Table
            className="max-h-screen"
            columns={negotiationsListTableColumns}
            isLoadingData={negotiationsIsFetching}
            rows={negotiations}
            rowEmptyValue="--"
            page={filterParams.page || 1}
            setPage={(p) => setFilterParams((params) => ({ ...params, page: p }))}
            totalPages={meta.total_pages}
            totalCount={meta.total}
          />
        </div>
      </ErrorMessageWrapper>
    </div>
  );
};

export default NegotiationsList;
